import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AttributeSplit = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <rect x="4" y="2" width="16" height="8" rx="2" fill={getColor(color, isColorInherited)} />
    <path
      d="M5 22H8.79289C9.23835 22 9.46143 21.4614 9.14645 21.1464L4.85355 16.8536C4.53857 16.5386 4 16.7617 4 17.2071V21C4 21.5523 4.44772 22 5 22Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M20 21L20 17.2071C20 16.7617 19.4614 16.5386 19.1464 16.8536L14.8536 21.1464C14.5386 21.4614 14.7617 22 15.2071 22L19 22C19.5523 22 20 21.5523 20 21Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12 6V13.5858C12 13.851 11.8946 14.1054 11.7071 14.2929L7 19"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
    />
    <path d="M18 20L14 16" stroke={getColor(color, isColorInherited)} strokeWidth="2" />
  </SvgIcon>
);
